// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BrvT","title":"styles_title__1A_kg"};